export const getHourOfTheDay = (hourNumber: number): string => (
  `${hourNumber === 12 ? 12 : hourNumber % 12}:00 ${hourNumber >= 12 ? 'pm' : 'am'}`
);
